/*
 * @Author: li
 * @Date: 2017-11-30 14:05:50
 * @Last Modified by: li
 * @Last Modified time: 2017-12-07 13:56:42
 */
class Native {
  constructor() {
    this.platform = this.ua()
    this.paramsFunc = {
      goToContainer: ['title', 'url']
    }
    window['JSInterface'] = {}
  }
  ua() {
    const ua = typeof window !== 'undefined' && 'navigator' in window && 'userAgent' in navigator && navigator.userAgent.toLowerCase() || ''
    const iPad = ua.match(/ipad/), // null or ['mac os x', index: 30, input: 'xx']
      //some wp platform fake ua to android
      Android = ua.match(/android/) && !ua.match(/windows phone/),
      iOS = ua.match(/iphone/),
      WinPhone = ua.match(/windows phone/),
      Mac = ua.match(/mac os x/),
      Windows = ua.match(/window/),
      Linux = ua.match(/linux/),
      Blackberry = ua.match(/blackberry/),
      Tablet = /ipad|android(?!.*mobile)/i.test(ua),
      AndroidTablet = /android/.test(ua) && !/mobile/.test(ua);
    const device = [
      iPad, Android, iOS, WinPhone, Mac, Windows, Linux, Blackberry, Tablet, AndroidTablet
    ];
    const arrDevice = [
      "iPad", "android", "ios", "windowsPhone", "mac", "windows",
      "linux", "blackBerry", "tablet", "androidTablet"
    ];
    for (let k = 0; k < device.length; k++) {
      if (device[k]) {
        return arrDevice[k];
      }
    }
    return "unknow";
  }
  emit(type, params) {
    try {
      if (this.platform === 'android') {
        if (JSON.stringify(params) === '{}') {
          params = ''
        }
        if (!params) {
          window && window.jsObj && window.jsObj[type] && window.jsObj[type]()
        } else if (typeof params === 'string') {
          window && window.jsObj && window.jsObj[type] && window.jsObj[type](params)
        } else if (typeof params === 'object') {
          window && window.jsObj && window.jsObj[type] && window.jsObj[type](JSON.stringify(params))
        }
      } else if (['ios', 'ipad'].includes(this.platform)) {
        window.webkit && window.webkit.messageHandlers[type]['postMessage'](typeof params == 'string' ? params : JSON.stringify(params))
      }
    } catch (err) {
      console.log(err)
    }
  }
}
export default new Native()
